import RibbonsContainer from "../../../Components/BonusUi/Ribbons/RibbonsConrainer";

const Ribbons = () => {
  return <RibbonsContainer />;
};

export default Ribbons;
